import { StyledInput } from './SearchInput.styled';

interface ISearchInputProps
	extends Omit<React.HTMLAttributes<HTMLDivElement>, 'onChange'> {
	onChange: (text: string) => void;
}

const SearchInput: React.FC<ISearchInputProps> = ({ onChange, ...props }) => {
	return <StyledInput {...props} onChange={(e) => onChange(e.target.value)} />;
};

export { SearchInput };
